import { CommonModule, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { UploadQuotationModalComponent } from "../../components/quotation/upload-quotation-modal/upload-quotation-modal.component";
import { FormStorageService } from '../../services/form-storage.service';
import { FormsModule } from '@angular/forms';
import { FilterQuotationModalComponent } from '../../components/quotation/filter-quotation-modal/filter-quotation-modal.component';

interface Quoatation{
  name: string;
  uploadDate: string;
  status: string;
}

@Component({
  selector: 'app-quotation-page',
  imports: [NgIf, CommonModule, FormsModule, FilterQuotationModalComponent, UploadQuotationModalComponent],
  templateUrl: './quotation-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})

export class QuotationPageComponent implements OnInit { 
  quotations: Quoatation[] = [];
  showModal = false;
  showFilterModal = false;

  // Opciones de filtro
  sortOption: 'fecha' | 'alfabetico' = 'fecha'; 
  filterText = '';
  filterStartDate: string | null = null;
  filterEndDate: string | null = null;

  private readonly STORAGE_KEY = 'quotationDocs';

  constructor(
    private formStorage: FormStorageService,
  ){}

  ngOnInit(): void {
    const savedQuotations = this.formStorage.load<Quoatation[]>(this.STORAGE_KEY);
    if (savedQuotations){
      this.quotations = savedQuotations;
    }
  }

  openModal() {
    this.showModal = true;
  }

  closeModal(){
    this.showModal = false;
  }

  handleFileUpload(file: File){
    const newQuotation: Quoatation = {
      name: file.name,
      uploadDate: new Date().toLocaleDateString('es-ES', {
        day:'2-digit',
        month: '2-digit',
        year: 'numeric',
      }),
      status: 'Descargar',
    };

    this.quotations.push(newQuotation);
    this.formStorage.save(this.STORAGE_KEY, this.quotations);

    this.closeModal();
  }

  sortQuotations(option: 'fecha' | 'alfabetico'){
    this.sortOption = option;
    if( option === 'alfabetico'){
      this.quotations.sort((a,b) => a.name.localeCompare(b.name));
    }else{
      this.quotations.sort(
        (a,b) => new Date(b.uploadDate.split('/').reverse().join('-')).getTime() - 
                 new Date(a.uploadDate.split('/').reverse().join('-')).getTime()
      );
    }
  }

  get filteredQuotations() { 
    return this.quotations.filter((q) => {
      const matchesText = this.filterText === '' || q.name.toLowerCase().includes(this.filterText.toLowerCase());

      const uploadDate = new Date(q.uploadDate.split('/').reverse().join('-'));
      const startDate = this.filterStartDate ? new Date(this.filterStartDate) : null;
      const endDate = this.filterEndDate ? new Date(this.filterEndDate) : null;
      const matchesDate = (!startDate || uploadDate >= startDate) && (!endDate || uploadDate <= endDate);

      return matchesText && matchesDate;
    });
  }

  onDateRangeSelected(range: { start: Date | null, end: Date | null }) {
    this.filterStartDate = range.start ? range.start.toISOString() : null;
    this.filterEndDate = range.end ? range.end.toISOString() : null;
  }

  onApplyFilters(filters: { text: string; startDate: Date | null; endDate: Date | null }) {
    this.filterText = filters.text;
    this.filterStartDate = filters.startDate ? filters.startDate.toISOString() : null;
    this.filterEndDate = filters.endDate ? filters.endDate.toISOString() : null;
    this.showFilterModal = false;
  }

  get currentFilters() {
  return {
    text: this.filterText,
    startDate: this.filterStartDate ? new Date(this.filterStartDate) : null,
    endDate: this.filterEndDate ? new Date(this.filterEndDate) : null,
  };
}
  hasActiveFilters(): boolean {
    return (
      this.filterText !== '' || this.filterStartDate !== null || this.filterEndDate !== null
    );
  }

  clearAllFilters(){
    this.filterText = '';
    this.filterStartDate = null;
    this.filterEndDate = null;
  }
}
